/**
 * Mixpanel event names for policy rules analytics.
 * Maps policy rule categories to edit/save events and exposes global policy-list events.
 */
import { POLICY_RULE_CATEGORY } from "../policy-types";

export const POLICY_RULES_MIXPANEL_ADD_RULE = "d&_settings_return_policy_add_rule";
export const POLICY_RULES_MIXPANEL_SAVE_NEW_RULE = "d&_settings_return_policy_save_new_rule";
export const POLICY_RULES_MIXPANEL_DROP_ADD_RULE = "d&_settings_return_policy_drop_add_rule";

const EDIT_BY_CATEGORY: Record<POLICY_RULE_CATEGORY, string> = {
	[POLICY_RULE_CATEGORY.EXCHANGE]: "d&_settings_return_policy_exchange_edit",
	[POLICY_RULE_CATEGORY.RETURN]: "d&_settings_return_policy_return_edit",
	[POLICY_RULE_CATEGORY.ORDER_MODIFICATION]: "d&_settings_return_policy_order_modification_edit",
};

const SAVE_BY_CATEGORY: Record<POLICY_RULE_CATEGORY, string> = {
	[POLICY_RULE_CATEGORY.EXCHANGE]: "d&_settings_return_policy_exchange_save",
	[POLICY_RULE_CATEGORY.RETURN]: "d&_settings_return_policy_return_save",
	[POLICY_RULE_CATEGORY.ORDER_MODIFICATION]: "d&_settings_return_policy_order_modification_save",
};

export function getPolicyRulesMixpanelEditEvent(category: POLICY_RULE_CATEGORY): string {
	return EDIT_BY_CATEGORY[category];
}

export function getPolicyRulesMixpanelSaveEvent(category: POLICY_RULE_CATEGORY): string {
	return SAVE_BY_CATEGORY[category];
}
